import { state, props } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import setUnit from '../actions/setUnit'
import resetSizesForUnit from '../actions/resetSizesForUnit'

export default [
  set(props`oldUnit`, state`basket.unit`),
  setUnit,
  resetSizesForUnit
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/setUnit.js